import React, { FC, FormEvent, useState } from 'react'
import { useHistory } from 'react-router-dom'

import LoginForm from '../../components/LoginForm/LoginForm.component'
import { useLogin } from '../../hooks/useAuth'
import { Container } from './Login.style'
import CreateAccountCTA from '@components/CreateAccountCTA/CreateAccountCTA.component'
import { getLanguageBasedOnDomain } from '@utils/getDomainExtension'
import { useTranslation } from 'react-i18next'
import { SeoHead } from '@components/SeoHead/SeoHead.component'

const Login: FC = () => {
    const { i18n } = useTranslation()
    const seoLang = i18n.getFixedT(getLanguageBasedOnDomain())
    const [loading, setLoading] = useState(false)
    const [loginError, setLoginError] = useState(false)

    const login = useLogin()
    const history = useHistory()

    const onLoginClick = async (
        e: FormEvent<HTMLFormElement> | null,
        email: string,
        password: string,
        autoLogin = false
    ) => {
        if (e) {
            e.preventDefault()
        }
        setLoading(true)
        setLoginError(false)

        try {
            const token = await login(email, password, history, autoLogin)
            if (token === null) {
                setLoading(false)
                setLoginError(true)
            }
        } catch (error) {
            setLoading(false)
            setLoginError(true)
        }
    }

    return (
        <>
            <SeoHead title={seoLang('seo.pages.loginTitle')} description={seoLang('seo.pages.loginDescription')} />

            <Container>
                <LoginForm
                    loading={loading}
                    setLoading={setLoading}
                    onLoginClick={onLoginClick}
                    loginError={loginError}
                />
                <CreateAccountCTA />
            </Container>
        </>
    )
}

export default Login
